const chartStyles = {
  '& [class^="chartTitle-"]': {
    display: 'none',
  },
  '& div[class*="singleChartRoot"]': {
    margin: '0',
    padding: '0',
  },
  '& .ms-StackedBarChart': {
    gap: '0',
  },
};

const deviceComparisonCard = footerVisible => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flexGrow: 1,
  paddingTop: footerVisible ? '5px' : '10px',
});

const dropdownComparisonCard = footerVisible => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: footerVisible ? '0px' : '10px',
});

const gridContainerStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  gridTemplateRows: 'auto auto',
  gap: '5px',
  alignItems: 'center',
};

const dataItem = {
  display: 'flex',
  alignItems: 'center',
};

const separator = {
  borderLeft: '1px solid #ccc',
  height: '135%',
  paddingRight: 10,
};

const customCallout = {
  padding: '15px',
  width: '400px',
  lineHeight: '1.8',
};

const multiStackedBarChart = {
  margin: 0,
  padding: 0,
  height: '42px',
};

const comparisonCardPattern = {
  position: 'absolute',
  left: 0,
  top: 0,
  overflow: 'hidden',
  width: '10px',
  height: '10px',
};

const legend = {
  paddingLeft: '4px',
};

const leftGrid = {
  gridColumn: '1 / 2',
};

const rightGrid = {
  gridColumn: '3 / 4',
};

export const getStyles = footerVisible => ({
  deviceComparisonCard,
  dropdownComparisonCard: dropdownComparisonCard(footerVisible),
  gridContainerStyle,
  legend,
  leftGrid,
  rightGrid,
  dataItem,
  separator,
  customCallout,
  comparisonCardPattern,
  multiStackedBarChart: { ...multiStackedBarChart, ...chartStyles },
});
